import { ChangeDetectorRef, Component, ViewChild, HostListener } from '@angular/core';
import { Router, RouterOutlet, RouterModule, NavigationEnd } from '@angular/router';
import { FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { JwtToken, LoginResponseBody, Organisation } from '../models/types';
import { RegisterPageComponent } from './register-page/register-page.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { FullCalendarModule } from '@fullcalendar/angular';
import { RouteName } from '../models/enums';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMoon, faSun, faCartShopping, faShop, faMagnifyingGlass, faBars, faCalendar, faTractor, faRightToBracket, faRightFromBracket, faUser, faUserTie, faCircleInfo, faHouse, faBuilding} from '@fortawesome/free-solid-svg-icons';
import { LoginService } from './services/login.service';
import { PersonalizationService } from './services/personalization.service';
import { ProfilePageService } from './services/profile-page.service';
import { icon, Marker } from 'leaflet';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDropdownDirective, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FooterComponent } from "./footer/footer.component";
import { OrganisationSlugReverseMap } from '../models/enums';

const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const shadowUrl = 'assets/marker-shadow.png';
const iconDefault = icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});
Marker.prototype.options.icon = iconDefault;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    FormsModule,
    RegisterPageComponent,
    NgxCaptchaModule,
    ReactiveFormsModule,
    FullCalendarModule,
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    NgbModule,
    BsDropdownModule,
    FooterComponent
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'hotedrsica.si';
  showTopBar = true;
  showSideBar = false;
  onDashboard = false;
  lastScrollTop = 0;
  navbarVisible = true;

  faMoon = faMoon;
  faSun = faSun;
  faShop = faShop;
  faCalendar = faCalendar;
  faTractor = faTractor;
  faRightToBracket = faRightToBracket;
  faRightFromBracket = faRightFromBracket;
  faUser = faUser;
  faBars = faBars;
  faUserTie = faUserTie;
  faCircleInfo = faCircleInfo;
  faHouse = faHouse;
  faBuilding = faBuilding;

  marketRoute = RouteName.market;
  calendarRoute = RouteName.calendar
  farmsRoute = RouteName.farms;
  helpRoute = RouteName.help;
  homeRoute = RouteName.home;

  adminFarmProfileRoute = '/admin-farm-profile';
  farmRegisterRoute: string = `/${RouteName.farmRegister}`;

  @ViewChild("dropdown") dropdownMenuRef!: BsDropdownDirective;

  isLoggedIn = false;
  isAdminLoggedIn = false;
  isDropdownOpen = false;
  onRegisterPage = false;

  isDarkMode = false;
  currentFarm: any | null;

  currentUserID: number | null = null;
  currentUserUsername: string | null = null;
  userHasFarm = false;

  organisations: Organisation[] = [];
  isTransparent: boolean = true;
  footerBgColor: string = '#972f32';
  slugMap = OrganisationSlugReverseMap;

  organisationColors: { [key: string]: string } = {
    'sd-hot': '#2596BE', 
    'pgd-hot': '#D0291D', 
    'ks-hot': '#972f32', 
    'z-hot': '#bb9002ff',
    '6': '#ffc300',
    '7': '#ffc300'
  };

  constructor(
    private router: Router,
    private loginService: LoginService,
    private personalizationService: PersonalizationService,
    private profilePageService: ProfilePageService,
    private cdr: ChangeDetectorRef,
  ) {}


  async ngOnInit() { 
    this.loadOrganisations();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        this.updateFooterColor();
      }
    });
    this.onDashboard = this.isOnDashboard()
    this.isLoggedIn = this.loginService.IsUserLoggedIn();
    this.onRegisterPage = this.isOnRegisterPage();

    
    this.currentUserID = this.loginService.GetLoggedInUserInfo()!.userID;
    this.currentUserUsername = this.loginService.GetLoggedInUserInfo()!.username;

    console.log("Current User ID: ", this.currentUserID);
    console.log("Is Admin Logged In: ", this.isAdminLoggedIn);
    this.profilePageService.getFarmInfo(this.currentUserID!).subscribe(
      (response) => {
        this.currentFarm = response.body!;
        console.log("Current Farm: ", this.currentFarm);
        this.userHasFarm = true;  // User has a farm if we get a valid response
        this.adminFarmProfileRoute = `admin-farm-profile`;
        console.log("Admin Farm Profile Route: ", this.adminFarmProfileRoute);
      },
      (error) => {
        if (error.status === 404) {
          this.userHasFarm = false;  // No farm found, set to false
        } else {
          console.error("An error occurred while fetching farm info:", error);
          // Handle other errors or set userHasFarm to a default state if necessary
        }
      }
    );

    this.router.events.subscribe({
      next: (event) => {
        if (this.router.url == "/" + RouteName.dashboard) {
          this.showTopBar = false;
          this.showSideBar = true;
        } else if (this.router.url == "/" + RouteName.home) {
          this.showSideBar = false;
          this.showTopBar = true;
        }
      }
    });
  }

  isOnDashboard() {
    const url = window.location.href
    if(url.includes(RouteName.dashboard)) {
      return true
    }
    return false
  }

  isOnRegisterPage() {
    const url = window.location.href
    if(url.includes(RouteName.register)) {
      return true
    }
    return false
  }

  normalizeName(name: string): string {
    return name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  ChangeTheme(){
    const body = document.querySelector("body");
    const currentTheme = body?.getAttribute("data-bs-theme");
    if (currentTheme === "dark") {
      body?.setAttribute("data-bs-theme", "light");
      this.isDarkMode = false;
      this.personalizationService.SetTheme(true);
    } else {
      body?.setAttribute("data-bs-theme", "dark");
      this.isDarkMode = true;
      this.personalizationService.SetTheme(false);
    }
  }

  logout() {
    this.loginService.ClearToken();
    this.router.navigate(["/" + RouteName.market]);
    window.location.reload();
  }

  loadOrganisations() {
    this.loginService.getAllOrganisations().subscribe({
      next: (response) => {
        if (response.body && Array.isArray(response.body.organisations)) {
          this.organisations = response.body.organisations
            .filter((org: Organisation) => org.organisationID !== -1)
            .map((org: Organisation) => {
              const normalizedName = this.normalizeName(org.name);
              const slug = OrganisationSlugReverseMap[normalizedName];
  
              if (!slug) {
              }
  
              return {
                ...org,
                slug: slug || '' // Avoid undefined to prevent routing issues
              };
            });
  
          this.cdr.detectChanges(); // Manually trigger change detection
  
          const orgIDs = this.organisations.map(org => org.organisationID);
          this.isAdminLoggedIn = this.loginService.IsAdminLoggedIn() || this.loginService.IsAnyOrgAdminLoggedIn(orgIDs);
        } else {
          console.error('Unexpected response structure:', response.body);
        }
      },
      error: (err) => {
        console.error('Error fetching organisations:', err);
      }
    });
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen; // Toggle dropdown visibility
    console.log("Dropdown status: ", this.isDropdownOpen);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const clickedInside = (event.target as HTMLElement).closest('.dropdown-toggle');
    if (!clickedInside) {
      this.isDropdownOpen = false;
    }
  }

  updateFooterColor() {
    const urlSegments = this.router.url.split('/'); // Split the URL into parts
    const orgIndex = urlSegments.indexOf('organisation'); // Find the "organisation" segment
    const orgId = orgIndex !== -1 ? urlSegments[orgIndex + 1] : null; // Get the next segment as slug
    console.log('Organisation ID:', orgId, 'Footer color:', this.organisationColors[orgId!], 'orgId', orgId);
    // Set footer color based on the extracted organization ID
    this.footerBgColor = orgId && this.organisationColors[orgId] ? this.organisationColors[orgId] : '#972f32';
  }
}
